// Imports
import styled from "styled-components"
import { Mixins, Variables } from "fajny-react"

const DemoCard = styled.div`
    width: 100%;
    border: 1px solid ${Variables.Colors.Gray200};
    border-radius: ${Variables.Radiuses.M};
    overflow: hidden;
    ${Mixins.Flexbox({
        $align: "center",
        $justify: "flex-start",
    })};
`

export default DemoCard
